import "./Hero01.css";
import pic01 from "../img/cont/gif-01.gif";

function Hero01() {
  return (
    <div class="Hero01 section">
      <div class="container">
        <div class="Hero01-box">
          <div>
            <h1>$Zhǐwǔ</h1>
            <p>Unveiling the Forgotten Knowledge...</p>

            <a href="" target="_blank" rel="noopener noreferrer">
              <button class="btn03">BUY $Zhǐwǔ NOW</button>
            </a>
          </div>

          <div class="image-container">
            <img src={pic01} alt="mascot" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Hero01;
